module.exports = __webpack_public_path__ + "img/allottee2_7-8-2021.270f7da3.jpg";